import store from "../../store";

export const prepareKanbanData = docsArray => {
  const data = {};
  const state = store.getState();
  const { assetStatusList } = state.AssetStore;
  const { kanbanStatusMap } = state.KanbanStore;

  if (
    (!assetStatusList || assetStatusList.length === 0) &&
    Object.keys(kanbanStatusMap).length === 0
  ) {
    return {};
  }

  assetStatusList.forEach(status => {
    data[status.name] = [];
  });
  docsArray.forEach(doc => {
    Object.keys(data).forEach(key => {
      if (
        doc.document_status &&
        doc.document_status.id === kanbanStatusMap[key].id
      ) {
        data[key].push(doc);
      }
    });
  });
  return data;
};

export const prepareStatusMap = statusArray => {
  if (statusArray.length === 0) {
    return {};
  }
  const statusMap = {};
  statusArray.forEach(status => {
    statusMap[status.name] = status;
  });
  return statusMap;
};

export const reArrangeKanbanDocs = (newStatus, oldStatus, docID) => {
  const { kanbanDocs, kanbanStatusMap } = store.getState().KanbanStore;

  const docToBeUpdated = kanbanDocs[oldStatus].find(
    doc => doc.id === parseInt(docID, 10),
  );

  const docsWithOldStatus = kanbanDocs[oldStatus].filter(
    doc => doc.id !== parseInt(docID, 10),
  );

  const updatedDoc = {
    ...docToBeUpdated,
    document_status: kanbanStatusMap[newStatus],
  };

  const docsWithNewStatus = [updatedDoc, ...kanbanDocs[newStatus]];

  const newKanbanDocs = {
    ...kanbanDocs,
    [newStatus]: docsWithNewStatus,
    [oldStatus]: docsWithOldStatus,
  };

  return newKanbanDocs;
};
